module.exports = __webpack_public_path__ + "static/media/i-done-circle.9dd400eb.svg";